import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {Legend, Pie, PieChart, ResponsiveContainer, Tooltip} from 'recharts';

const SystemAdminDashboard = (props) => {
	const {state, translate} = props;
	const {workOrderStat, regionStat} = state;

	const pieChartData = [
		{name: 'New', value: workOrderStat.new, fill: '#00c0ef'},
		{name: 'Approved', value: workOrderStat.approved, fill: '#00a65a'},
		{name: 'Not Approved', value: workOrderStat.not_approved, fill: '#f39c12'},
		{name: 'Alerted', value: workOrderStat.alert, fill: '#dd4b39'}
	];

	return (
		<Fragment>
			<div className='row'>
				<div className='col-sm-12'>
					<div className="small-box bg-teal-active">
						<div className="inner text-center">
							<p>{translate('dashboard_page_work_order_stat_total')}</p>
							<h3>{workOrderStat.total}</h3>
						</div>
						<div className="icon">
							<i className="fa fa-book"/>
						</div>
					</div>
				</div>
			</div>

			<div className="row">
				<div className="col-sm-4">
					<div className="row">
						<div className="col-sm-6">
							<div className="small-box bg-aqua">
								<div className="inner">
									<p>{translate('dashboard_page_work_order_stat_new')}</p>
									<h3>{workOrderStat.new}</h3>
								</div>
								<div className="icon">
									<i className="fa fa-plus"/>
								</div>
							</div>
						</div>
						<div className="col-sm-6">
							<div className="small-box bg-green">
								<div className="inner">
									<p>{translate('dashboard_page_work_order_stat_approved')}</p>
									<h3>{workOrderStat.approved}</h3>
								</div>
								<div className="icon">
									<i className="fa fa-check"/>
								</div>
							</div>
						</div>
						<div className="col-sm-6">
							<div className="small-box bg-yellow">
								<div className="inner">
									<p>{translate('dashboard_page_work_order_stat_not_approved')}</p>
									<h3>{workOrderStat.not_approved}</h3>
								</div>
								<div className="icon">
									<i className="fa fa-ban"/>
								</div>
							</div>
						</div>
						<div className="col-sm-6">
							<div className="small-box bg-red">
								<div className="inner">
									<p>{translate('dashboard_page_work_order_stat_alerted')}</p>
									<h3>{workOrderStat.alert}</h3>
								</div>
								<div className="icon">
									<i className="fa fa-exclamation-triangle"/>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="col-sm-4">
					<div className="box">
						<div className="box-body">
							<ResponsiveContainer height={200}>
								<PieChart>
									<Pie dataKey="value" innerRadius={40} outerRadius={80} paddingAngle={10}
									     label={{fill: '#000'}} data={pieChartData}
									/>
									<Tooltip/>
									<Legend/>
								</PieChart>
							</ResponsiveContainer>
						</div>
					</div>
				</div>
				<div className="col-sm-4">
					<div className="box">
						<div className="box-body with-top-padding">
							<div className="table-responsive">
								<table className="table table-bordered table-striped table-condensed text-center">
									<thead>
										<tr>
											<th>{translate('dashboard_page_region_stat_name')}</th>
											<th>{translate('dashboard_page_region_stat_new')}</th>
											<th>{translate('dashboard_page_region_stat_approved')}</th>
											<th>{translate('dashboard_page_region_stat_not_approved')}</th>
											<th>{translate('dashboard_page_region_stat_alerted')}</th>
										</tr>
									</thead>
									<tbody>
									{
										Object.keys(regionStat).map((key, index) => (
											<tr key={`dashboard_page_region_stat_${index}`}>
												<td>{regionStat[key].name}</td>
												<td>{regionStat[key].wo_new}</td>
												<td>{regionStat[key].wo_approved}</td>
												<td>{regionStat[key].wo_not_approved}</td>
												<td>{regionStat[key].wo_alert}</td>
											</tr>
										))
									}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Fragment>
	);
};

SystemAdminDashboard.defaultProps = {
};

SystemAdminDashboard.propTypes = {
	state: PropTypes.object.isRequired,
	translate: PropTypes.func.isRequired
};

export default SystemAdminDashboard;